import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { apiGet, ApiError } from '../lib/api'
import { Logo } from '../components/Logo'

export default function AuthVerify() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setError('Link inválido o expirado')
      return
    }

    const installId = searchParams.get('install_id')
    apiGet<{ user: { officeId: string | null }; office: unknown }>(`/api/auth/verify?token=${encodeURIComponent(token)}`)
      .then((data) => {
        if (data.office) {
          navigate('/professional', { replace: true })
        } else {
          // Pass install_id so Setup can complete the App Store install even cross-browser
          const setupPath = installId ? `/setup?install_id=${encodeURIComponent(installId)}` : '/setup'
          navigate(setupPath, { replace: true })
        }
      })
      .catch((err) => {
        if (err instanceof ApiError) {
          setError(err.message || 'Link inválido o expirado')
        } else {
          setError('Link inválido o expirado')
        }
      })
  }, [searchParams, navigate])

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: 'linear-gradient(135deg, #e8f4fd 0%, #f4f7fa 50%, #e8f0f8 100%)' }}
    >
      <div className="card w-full max-w-sm p-8 shadow-lg text-center">
        <div className="flex justify-center mb-8">
          <Logo size="md" />
        </div>

        {error ? (
          <>
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
              style={{ background: 'color-mix(in srgb, var(--error) 10%, transparent)' }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ color: 'var(--error)' }}
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold mb-2" style={{ color: 'var(--foreground)' }}>
              {error}
            </h2>
            <p className="text-sm mb-6" style={{ color: 'var(--muted)' }}>
              El link puede haber expirado o ya fue utilizado.
            </p>
            <Link to="/login" className="btn-primary">
              Solicitá un nuevo link
            </Link>
          </>
        ) : (
          <>
            <div
              className="w-12 h-12 rounded-full border-4 border-t-transparent animate-spin mx-auto mb-4"
              style={{ borderColor: 'var(--border)', borderTopColor: 'var(--primary)' }}
            />
            <p className="text-base font-medium" style={{ color: 'var(--foreground)' }}>
              Verificando...
            </p>
          </>
        )}
      </div>
    </div>
  )
}
